export class ProgramGuest {
  public id: number;
  public name: string;
}
